export default {
      id: "demote-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#demote",
      toString: function () {
        return this.url;
      }
    }